module.exports = __webpack_public_path__ + "static/assets/1dd85084f06c0aa3f6cf9b26b2204577.svg";